"use strict";
// misc utilities when working with particular programming languages
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeSqlValue = exports.printSQLQuery = void 0;
var _1 = require(".");
/** when executing sql queries on we often invoke
 * `await query('select foo from bar where userId=?', [userId])`
 * Use this function when you have lots of parameters to generate an executable query ready to debug
 * (joins/escapes params into the sql string). Supports strings, numbers lists and dates */
function printSQLQuery(sql, params) {
    var counter = 0;
    return sql
        .replace(/(\?)/g, function (txt, key) {
        return escapeSqlValue(params[counter++]);
    });
}
exports.printSQLQuery = printSQLQuery;
function escapeSqlValue(value) {
    if (typeof value === 'string') {
        return "" + _1.quote(value, '"');
    }
    else if (value instanceof Date) {
        return _1.formatDateTimeForSql(value);
    }
    else if (Array.isArray(value)) {
        return value.map(escapeSqlValue).join(',');
    }
    else {
        return "" + value;
    }
}
exports.escapeSqlValue = escapeSqlValue;
//# sourceMappingURL=langs.js.map